<template >  
    <div >
        <img class="wave" src="img/wave.png">
      <div class="container">
        <div class="img">
          <img src="img/bg.svg"> 
        </div>
		<div class="login-content">
      <div v-if="loading" class="loading-container">
                <RotateSquare
                  class="loading-position animated fadeIn"
                  size="60px"
                ></RotateSquare>
              </div>
      <form class="formLogin" v-else @submit="onFormValidate">
				<img src="img/avatar.svg">
                  <div>
                    <b-dropdown
                      id="ddown2"
                      :text="idiomaSelecionado"
                      toggle-class="dropLogin"
                    >
                      <b-dropdown-item @click="MudarIdioma('pt-BR')">
                        {{ $t("languages.ptBR") }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="MudarIdioma('es')">
                        {{ $t("languages.es") }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>

           		<div class="input-div one">
           		   <div class="i">
           		   		<i class="fas fa-user"></i>
           		   </div>
           		   <div class="div">
                  <h5>{{$t('sectionLogin.user')}}</h5>
                  <input
                      v-model="email"
                      type="text"
                      class="input"
                      required
                    />
           		   </div>
           		</div>
           		<div class="input-div pass">
           		   <div class="i"> 
           		    	<i class="fas fa-lock"></i>
           		   </div>
           		   <div class="div">
                  <h5>{{$t('sectionLogin.password')}}</h5>
           		    	<input
                      v-model="senha"
                      type="password"
                      class="input"
                      required
                    />
            	   </div>
            	</div>
              <div
                    v-if="mensagem"
                    class="alert alert-warning alert-dismissible fade show"
                    role="alert"
                  >
                    <strong>{{ mensagem }}</strong>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                      @click="Fechar()"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  
                  <button class="btnLogin " @click="Login()" >
                        {{ $t("loginTextH1") }}
                      </button>
              <button
                    class="a btn-link"
                    @click="$router.push('/esqueci-senha')"
                  >
                    {{ $t("sectionLogin.forgotPassword") }}
                  </button>

                <div >
                  <a class="a"
                    href="https://prismafive.com.br/politica-de-privacidade/"
                    target="_blank"
                  >
                    {{ $t("acceptPrivacy") }}
                  </a>
                </div>
              </form>
        </div>
    </div>
    </div>
  
</template>


<script>

import RotateSquare from "../../components/RotateSquare";

import "../../assets/styles/scss/style.css"
export default {
  name: "Login",
  components: { RotateSquare },
  data() {
    return {
      idiomaSelecionado: this.$t("languages.ptBR"),
      loading: false,
      email: "",
      senha: "",
      mensagem: ""
    };
  },
  computed: {
    ViewModel() {
      return {
        Login: this.email,
        Senha: this.senha
      };
    }
  },
  watch: {
    "$i18n.locale"(idiomaSelecionado) {
      const ptBR = "pt-BR";

      if (idiomaSelecionado === ptBR) {
        this.idiomaSelecionado = this.$t("languages.ptBR");
      } else {
        this.idiomaSelecionado = this.$t("languages.es");
      }
    }
  },
  mounted() {

    const inputs = document.querySelectorAll(".input");

    function addcl(){
      let parent = this.parentNode.parentNode;
      parent.classList.add("focus");
    }

    function remcl(){
      let parent = this.parentNode.parentNode;
      if(this.value == ""){
        parent.classList.remove("focus");
      }
    }

    inputs.forEach(input => {
      if(input.value) input.parentNode.parentNode.classList.add("focus");
      input.addEventListener("focus", addcl);
      input.addEventListener("blur", remcl);
    });

    if (this.$route.params.id && this.$route.params.sync) {
      this.email = this.$route.params.id;
      this.senha = this.$route.params.sync;
      this.LoginRedirect();
    }

    if (this.$route.params.id && !this.$route.params.sync) {
      this.$store.dispatch("logout");
      this.LoginPortal();
    }
    
    if (this.$store.getters.isLoggedIn) {
      this.$router.push("/");
    }
  },
  updated(){
    const inputs = document.querySelectorAll(".input");



    function addcl(){
      let parent = this.parentNode.parentNode;
      parent.classList.add("focus");
    }

    function remcl(){
      let parent = this.parentNode.parentNode;
      if(this.value == ""){
        parent.classList.remove("focus");
      }
    }

    

    inputs.forEach(input => {
      if(input.value) input.parentNode.parentNode.classList.add("focus");
      input.addEventListener("focus", addcl);
      input.addEventListener("blur", remcl);
    });
  },
  methods: {
    onPaste(event) {
      event.preventDefault();
      setTimeout(() => {
        console.log(event)
        this.email = event.clipboardData.getData("text");
      }, 10);
    },



    MudarIdioma(idiomaSelecionado) {
      this.$i18n.locale = idiomaSelecionado;
    },
    onFormValidate() {
      if (this.email.trim() || this.senha) {
        return;
      }
      this.preventDefault();
    },
    Fechar() {
      this.mensagem = "";
    },
    redirect(url,viewModel){
      window.location.href = url+"/"+viewModel.Login+"/"+viewModel.Senha;
      
    },
    Login() {
      this.loading = true;
      this.$http({
        url: "login",
        data: this.ViewModel,
        method: "POST"
      })
        .then((resp) => {
          this.loading = false;
          const token = resp.data;
          // Add the following line:
          this.$http.defaults.headers.common["Authorization"] =
            "bearer " + token.tokenDeAcesso;
            
            //if(window.location.href == resp.data.url || !resp.data.url || window.location.href == 'http://localhost:8080/#/login'){
            this.$store
              .dispatch("login", token)
              .then(() => this.$router.push("/"));
            //}else{
              //this.redirect(resp.data.url,this.ViewModel)
            //}

        })
        .catch((erro) => {
          this.loading = false;
          console.error("Erro Login:", erro);
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
          localStorage.removeItem("user-token");
        });
    },
    LoginPortal() {
      this.loading = true;
      this.$http({
        url: "login/autenticar-portal/" + this.$route.params.id,
        method: "GET"
      })
        .then((resp) => {
          this.loading = false;
          const token = resp.data;
          // Add the following line:
          this.$http.defaults.headers.common["Authorization"] =
            "bearer " + token.tokenDeAcesso;
          this.$store
            .dispatch("login", token)
            .then(() => this.$router.push("/"));
        })
        .catch((erro) => {
          this.loading = false;
          console.error("Erro PORTAL:", erro);
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });

          localStorage.removeItem("user-token");
        });
    },
    LoginRedirect(){
      
      this.loading = true;
      this.$http({
        url: "login",
        data: this.ViewModel,
        method: "POST"
      })
        .then((resp) => {
          this.loading = false;
          const token = resp.data;
          // Add the following line:
          this.$http.defaults.headers.common["Authorization"] =
            "bearer " + token.tokenDeAcesso;

            this.$store
            .dispatch("login", token)
            .then(() => 
            this.$router.push("/")
            );
          

        })
        .catch((erro) => {
          this.loading = false;
          console.error("Erro Login:", erro);
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
          localStorage.removeItem("user-token");
        });
    }
  }
};
</script>
 <style scoped>
#ddown2 {
  margin-top: 1rem;
}
/* 
.text-loginTextH1 {
  display: flex;
  flex-direction: column;
}

.container-title-login {
  display: flex;
  justify-content: space-between;
} */


</style> 
